export class SettleReportDeleteRequest {
  opinionId!:string
  constructor(opinionId:string) {
    this.opinionId = opinionId
  }
}
